export const statsSectionWrapper = {
  background: "#DDF472",
  padding: "6.25rem 7rem",
};
